export var TeaserBetTypes;
(function (TeaserBetTypes) {
    TeaserBetTypes["Teaser2Teams6Points"] = "Teaser2Teams6Points";
    TeaserBetTypes["Teaser2Teams6.5Points"] = "Teaser2Teams6.5Points";
    TeaserBetTypes["Teaser2Teams7Points"] = "Teaser2Teams7Points";
    TeaserBetTypes["Teaser3Teams6Points"] = "Teaser3Teams6Points";
    TeaserBetTypes["Teaser3Teams6.5Points"] = "Teaser3Teams6.5Points";
    TeaserBetTypes["Teaser3Teams7Points"] = "Teaser3Teams7Points";
    TeaserBetTypes["SuperTeaser3Teams10Points"] = "SuperTeaser3Teams10Points";
    TeaserBetTypes["Teaser4Teams6Points"] = "Teaser4Teams6Points";
    TeaserBetTypes["Teaser4Teams6.5Points"] = "Teaser4Teams6.5Points";
    TeaserBetTypes["Teaser4Teams7Points"] = "Teaser4Teams7Points";
    TeaserBetTypes["MonsterTeaser4Teams13Points"] = "MonsterTeaser4Teams13Points";
    TeaserBetTypes["Teaser5Teams6Points"] = "Teaser5Teams6Points";
    TeaserBetTypes["Teaser5Teams6.5Points"] = "Teaser5Teams6.5Points";
    TeaserBetTypes["Teaser5Teams7Points"] = "Teaser5Teams7Points";
    TeaserBetTypes["Teaser6Teams6Points"] = "Teaser6Teams6Points";
    TeaserBetTypes["Teaser6Teams6.5Points"] = "Teaser6Teams6.5Points";
    TeaserBetTypes["Teaser6Teams7Points"] = "Teaser6Teams7Points";
    TeaserBetTypes["Teaser2Teams4Points"] = "Teaser2Teams4Points";
    TeaserBetTypes["Teaser2Teams4.5Points"] = "Teaser2Teams4.5Points";
    TeaserBetTypes["Teaser2Teams5Points"] = "Teaser2Teams5Points";
    TeaserBetTypes["Teaser3Teams4Points"] = "Teaser3Teams4Points";
    TeaserBetTypes["Teaser3Teams4.5Points"] = "Teaser3Teams4.5Points";
    TeaserBetTypes["Teaser3Teams5Points"] = "Teaser3Teams5Points";
    TeaserBetTypes["SuperTeaser3Teams8Points"] = "SuperTeaser3Teams8Points";
    TeaserBetTypes["Teaser4Teams4Points"] = "Teaser4Teams4Points";
    TeaserBetTypes["Teaser4Teams4.5Points"] = "Teaser4Teams4.5Points";
    TeaserBetTypes["Teaser4Teams5Points"] = "Teaser4Teams5Points";
    TeaserBetTypes["MonsterTeaser4Teams10Points"] = "MonsterTeaser4Teams10Points";
    TeaserBetTypes["Teaser5Teams4Points"] = "Teaser5Teams4Points";
    TeaserBetTypes["Teaser5Teams4.5Points"] = "Teaser5Teams4.5Points";
    TeaserBetTypes["Teaser5Teams5Points"] = "Teaser5Teams5Points";
    TeaserBetTypes["Teaser6Teams4Points"] = "Teaser6Teams4Points";
    TeaserBetTypes["Teaser6Teams4.5Points"] = "Teaser6Teams4.5Points";
    TeaserBetTypes["Teaser6Teams5Points"] = "Teaser6Teams5Points";
})(TeaserBetTypes || (TeaserBetTypes = {}));
//# sourceMappingURL=TeaserBetTypes.js.map